export default "__VITE_ASSET__BXp$$d42__"